module.exports = __webpack_public_path__ + "img/icon-car.54154f5c.png";